export enum AdminErrorType {
	FUEL_SAVING_NEGATIVE = 'FUEL_SAVING_NEGATIVE',
}
